module.exports = __webpack_public_path__ + "img/innovation-norway-logo.43df24be.svg";